var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 12.0835L8.74952 8L4.66602 3.9165L5.91602 2.6665L11.2495 8L5.91602 13.3335L4.66602 12.0835Z",
    fill: "#998A7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingDetail);
export default __webpack_public_path__ + "static/media/pending-detail.386c0559cae860378784e1536c8c3bc0.svg";
export { ForwardRef as ReactComponent };